import { render, staticRenderFns } from "./EstablishmentRoleAdd.vue?vue&type=template&id=ae3b306c&"
import script from "./EstablishmentRoleAdd.vue?vue&type=script&lang=js&"
export * from "./EstablishmentRoleAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports